var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{staticClass:"overlay-component",attrs:{"show":_vm.isLoading,"no-wrap":""}})}
var staticRenderFns = []

export { render, staticRenderFns }